import { GovernanceConsumer } from '@injectivelabs/chain-consumer'
import { app } from './App'

export const govConsumer = new GovernanceConsumer(app.appUrlEndpoint.chainUrl)
